import { ArrowUpIcon } from "@app/design-system/icons";
import { BaseMarker } from "../BaseMarker";

export type PickupMarkerProps = {
  size?: number;
  color?: string;
};

/** Pickup location: BaseMarker + an upward-pointing arrow, per spec. */
export const PickupMarker = ({ size, color = "var(--color-icon-dark)" }: PickupMarkerProps) => (
  <BaseMarker size={size} color={color}>
    <ArrowUpIcon size={14} color={color} />
  </BaseMarker>
);
